// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"NestedMenu-module_buttonContainer__1ZfWwRGMHrM7J8JXopoAor","text":"NestedMenu-module_text__1zK6HBmkaZ9Qic9esuOLiD"};